module.exports = __webpack_public_path__ + "img/bg_shengfenzheng@2x.fcfb84ec.png";